export default {
  aboutUs: {},
  banner: {},
  selectedBanner: {},
  selectedContent: {},
};
